/** Clave sessionStorage para sesión de desarrollo (no persistir tokens OIDC aquí). */
export const AUTH_SESSION_STORAGE_KEY = 'mr_auth_session';

/** Clave sessionStorage para restaurar la ruta pedida tras volver del IdP. */
export const AUTH_RETURN_URL_STORAGE_KEY = 'mr_auth_return_url';

/**
 * Header interno: el interceptor reintenta un 401 una sola vez tras refresh.
 * No forma parte del contrato de las APIs Colmena.
 */
export const AUTH_RETRY_HEADER = 'X-MR-Auth-Retry';

/** Token Bearer acordado con backend (`DEV_AUTH_TOKEN`) en modo desarrollo. */
export const DEV_AUTH_BEARER_TOKEN = 'dev-bypass-token';

/**
 * `usu_id` del usuario técnico de desarrollo (alineado con `buildDevUser` en los MS).
 * Debe ser UUID RFC (v4): Ingesta valida `@IsUUID()` al cerrar el estado del archivo.
 */
export const DEV_USUARIO_ID = '00000000-0000-4000-8000-000000000018';
